module.exports = RedNaoFormBuilder.default('FormBuilder/Fields/Core/FBFieldWithPriceBase');